import React from "react";

/**
 * Creates an object URL for a PDF page blob.
 * URL is created/revoked in an effect (not useMemo) so React Strict Mode
 * remounts cannot reuse a revoked URL when the blob is already in the query cache.
 */
export const usePdfPageObjectUrl = (pageBlob: Blob | undefined) => {
  const [pageImageSrc, setPageImageSrc] = React.useState<string | null>(null);

  React.useEffect(() => {
    if (!pageBlob) {
      setPageImageSrc(null);
      return;
    }

    const objectUrl = URL.createObjectURL(pageBlob);
    setPageImageSrc(objectUrl);

    return () => {
      URL.revokeObjectURL(objectUrl);
    };
  }, [pageBlob]);

  return pageImageSrc;
};
